export const getOfferPlanLabel = ({ t, offerPlan }) => {
  const { frequency, resolution, currency, rental_duration, offer, price } =
    offerPlan;

  const yearFrequency =
    frequency % 12 === 0
      ? t("editor-offers:year", { count: frequency / 12 })
      : t("editor-offers:month", { count: frequency });

  const duration =
    offer.type === "svod"
      ? yearFrequency
      : `${rental_duration} ${t("editor-offers:days")}`;

  const frequencyPrefix = frequency ? "SVOD" : "Pack";

  return `${offer.label}: ${frequencyPrefix} - ${duration} - ${resolution} - ${price} ${currency}`;
};

export const getOfferOptions = ({ t, offerPlans }) =>
  offerPlans
    ?.filter(
      (offer_plan) =>
        offer_plan.platform === "okast" && offer_plan.type !== "free",
    )
    ?.map((offerPlan) => ({
      value: offerPlan.uuid,
      label: getOfferPlanLabel({ t, offerPlan }),
    }));
